export enum Path {
  HOME = '/',
  CATALOG = '/catalog',
  BRANDS = '/brands',
  CART = '/cart',
  PRODUCT = '/product',
  FAVORITES = '/favorites',
  RECENT_PRODUCTS = '/recentProducts',
  CHECK = '/check',
  BONUSES = '/bonuses',
  REFERRALS_LIST = '/bonuses/referrals',

  FORGET_PASSWORD = '/forgetPassword',
  RESET_PASSWORD = '/resetPassword',

  USER = '/user',
  DELETE_ACCOUNT = '/user/deleteAccount',
  ORDER = '/user/order',
  ORDERS = '/user/orders',
  PROFILE = '/user/profile',
  LOGIN = '/user/login',
  REGISTRATION = '/user/signup',
}
